<template>
  <aw-empty>
    <template #default>
      <lv-heading level="1" tag="h1" version2>
        {{ $awt('aw.pages.profile.empty.information') }}
      </lv-heading>
    </template>
    <template #button>
      <lv-button
        styling="primary-dark"
        @click="openLoginModal()"
      >
        {{ $awt('aw.pages.profile.empty.button') }}
      </lv-button>
    </template>
  </aw-empty>
</template>

<script setup>
  import { defineAsyncComponent } from 'vue';
  import { openLoginModal } from '~~/common/composables/useLoginModal';
  import { LvHeading, LvButton } from '~~/common/components/loginet-vue-shop/index';

  const AwEmpty = defineAsyncComponent(() => import('~~/common/components/Common/AwEmpty'));

</script>
